import {createAsyncThunk} from '@reduxjs/toolkit';
import api from 'services/axios';

export const getProducts = createAsyncThunk<any, any>(
  'components/getProducts',
  async (params, thunkApi) => {
    try {
      const response = await api.get(`/dasht/products`, {
        params: {
          vendor_id: params.vendor_id,
          search: params.search,
          stock_status: params.stock_status,
          badge: params.badge,
          page_size: params.page_size,
          page: params.page,
          sort: params.sort,
          category_id: params.category_id
        },
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);
